import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';

import CompanyService from '@services/CompanyService';

import { toastifyApiErrors } from '@utils';
import { useAuth } from '@hooks';

export function useAcceptResponsibilityLetter() {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { selectedPartnerCompany } = useAuth();

  const partnerCompany = selectedPartnerCompany?.partnerCompany ?? '';
  const responsibilityLetterStatus = true;

  const handleAcceptResponsibilityLetter = useCallback(async () => {
    try {
      setIsLoading(true);
      const companyService = new CompanyService();
      await companyService.acceptResponsibilityLetter({
        partnerCompany,
        responsibilityLetterStatus,
      });

      return true;
    } catch (error) {
      toastifyApiErrors(error, enqueueSnackbar);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [enqueueSnackbar, partnerCompany, responsibilityLetterStatus]);

  return { handleAcceptResponsibilityLetter, isLoading };
}
